import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const MONTHS = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];

const SolidarityCalendar = () => (
  <Box sx={{ maxWidth: 800, mx: 'auto', my: 4 }}>
    <Box
      component="svg"
      role="img"
      aria-label="El Solidarity Tax Credit se deposita el dia 5 de cada mes"
      viewBox="0 0 760 140"
      sx={{ width: '100%', height: 'auto', display: 'block' }}
    >
      {MONTHS.map((month, i) => {
        const cx = 38 + i * 58;
        return (
          <g key={month}>
            {/* Connector line */}
            {i > 0 && (
              <line
                x1={cx - 58 + 20}
                y1={45}
                x2={cx - 20}
                y2={45}
                stroke="#C8E6C9"
                strokeWidth="2"
              />
            )}
            {/* Circle */}
            <circle cx={cx} cy={45} r="20" fill="#1E3A5F" />
            {/* Day number */}
            <text
              x={cx}
              y={51}
              textAnchor="middle"
              fill="#fff"
              fontSize="16"
              fontWeight="600"
              fontFamily="Inter, sans-serif"
            >
              5
            </text>
            {/* Month label */}
            <text
              x={cx}
              y={84}
              textAnchor="middle"
              fill="#1A1A1A"
              fontSize="10"
              fontWeight="600"
              fontFamily="Inter, sans-serif"
            >
              {month}
            </text>
          </g>
        );
      })}

      {/* Dollar signs on first and last */}
      <text x={38} y={110} textAnchor="middle" fill="#1E3A5F" fontSize="11" fontWeight="600" fontFamily="Inter, sans-serif">
        $
      </text>
      <text x={38 + 11 * 58} y={110} textAnchor="middle" fill="#1E3A5F" fontSize="11" fontWeight="600" fontFamily="Inter, sans-serif">
        $
      </text>
    </Box>
    <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', color: '#5F6B7A', mt: 1 }}>
      El Solidarity Tax Credit se deposita el dia 5 de cada mes por depósito directo
    </Typography>
  </Box>
);

export default SolidarityCalendar;
